import {Modal} from '@yandex-delivery/blocks'
import React from 'react'

import DetailsList from './DetailsList'
import type {Props} from './types'

const DetailsDesktop: React.FC<Props> = ({onClose, classes, sections, title}) => {
  return (
    <Modal className={classes.paper} onClose={onClose} opened>
      <Modal.Title variant="title4">{title}</Modal.Title>
      <div data-e2e="details-modal-content">
        <DetailsList sections={sections} />
      </div>
    </Modal>
  )
}

export default DetailsDesktop
